import { Box, Button, Card, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PageHeaderLayout from "../../components/Layout/PageHeaderLayout";
import { PermissionGuard } from "../../components/PermissionGuard";
import { useNavigate } from "react-router-dom";
import { AddCircle, ArrowBack, Map } from "@mui/icons-material";
import ExcelJsonEditor from "./ExcelJsonEditor";
import ExcelLikeEditor from "./ExcelLikeEditor";

export default function TestingInterface(){
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'testing'
        });
    }, []);
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState('0');
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }
    return (
        <>
            <ExcelLikeEditor/>
        </>
    )
}